export default "/e891d4a0bdc60f2a6a9b4e97d7422547d2a79dc5/a2cdf02300b2663230f496dbfe02b4a0.svg";